export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-paperclip-b12b21528ba1298f630d48b69baeeb65.svg";